import { Button } from '@sqi/ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerSW } from 'virtual:pwa-register';
import { getActiveSession } from '../lib/auth';
import { pendingWorkerUpdateCount } from '../lib/oem-worker-handoff';

export function PwaUpdatePrompt() {
  const { t } = useTranslation();
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [offlineReady, setOfflineReady] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const updateWorker = useRef<((reloadPage?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    updateWorker.current = registerSW({
      immediate: false,
      onNeedRefresh: () => setUpdateAvailable(true),
      onOfflineReady: () => setOfflineReady(true),
    });
  }, []);

  const activateUpdate = async () => {
    const session = await getActiveSession();
    const pending = session === null ? 0 : await pendingWorkerUpdateCount(session.userId);
    if (pending > 0) {
      setBlocked(true);
      return;
    }
    await updateWorker.current?.(true);
  };

  if (!updateAvailable && !offlineReady && !blocked) return null;
  return (
    <aside className="pwa-prompt" role="status">
      <span>
        {blocked
          ? t('pwa.pendingBlocksUpdate')
          : updateAvailable
            ? t('pwa.updateAvailable')
            : t('pwa.offlineReady')}
      </span>
      {updateAvailable && !blocked ? (
        <Button onClick={() => void activateUpdate()}>{t('pwa.update')}</Button>
      ) : null}
      <Button
        aria-label={t('pwa.dismiss')}
        className="sqi-button--secondary"
        onClick={() => {
          setOfflineReady(false);
          setBlocked(false);
          setUpdateAvailable(false);
        }}
      >
        {t('pwa.dismiss')}
      </Button>
    </aside>
  );
}
